// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-emoji-picker__container{position:relative;cursor:pointer;height:32px}.c-emoji-picker__menu{position:absolute;bottom:100%;margin-bottom:5px;z-index:11;background-color:var(--background)}.c-emoji-picker__button{display:flex;align-items:center;justify-content:center;height:32px;color:var(--text--l2) !important}.c-emoji-picker__button-disabled{cursor:not-allowed;opacity:.5}", ""]);
// Exports
module.exports = exports;
